import jwt from "jsonwebtoken";
import { getSecondsDiff } from "./date";

export const isExpires = (token) => {
  if (!token) return true
  const tokenDecode = jwt.decode(token)
  if (!tokenDecode || !tokenDecode.exp) {
    // 만료일 없는 토큰 마스터 토큰
    return false
  }

  return getSecondsDiff(tokenDecode.exp * 1000) < 10 // 만료 10초전
}